import { cn } from '@reflex/ui/lib/utils';

export function StatusRow({
  icon: Icon,
  label,
  value,
  mono = true,
}: {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: string;
  mono?: boolean;
}) {
  return (
    <div className="flex gap-2">
      <Icon className="h-3.5 w-3.5 mt-px shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1">
        <div className="text-2xs font-medium text-muted-foreground mb-0.5">{label}</div>
        <div className={cn('text-xs break-all', mono && 'font-mono')}>{value}</div>
      </div>
    </div>
  );
}
